import { z } from "zod"

export const Fr24AircraftSchema = z.object({
    fr24_id: z.string(),
    hex: z.string().nullish(),
    lat: z.number(),
    lon: z.number(),
    timestamp: z.string(),
    flight: z.string().nullish(),
    callsign: z.string().nullish(),
    track: z.number().nullish(),
    alt: z.number().nullish(),
    gspeed: z.number().nullish(),
    vspeed: z.number().nullish(),
    // documented as a number, but the live API actually returns it as a string (sensibly, since
    // squawk codes can have leading zeros a JSON number can't represent) -- accept either
    squawk: z.union([z.string(), z.number()]).nullish(),
    source: z.string().nullish(),
    type: z.string().nullish(),
    reg: z.string().nullish(),
    painted_as: z.string().nullish(),
    operating_as: z.string().nullish(),
    orig_iata: z.string().nullish(),
    orig_icao: z.string().nullish(),
    dest_iata: z.string().nullish(),
    dest_icao: z.string().nullish(),
    eta: z.string().nullish(),
})

export type Fr24Aircraft = z.infer<typeof Fr24AircraftSchema>

export const Fr24FlightPositionsResponseSchema = z.object({
    data: z.array(Fr24AircraftSchema),
})

export type Fr24FlightPositionsResponse = z.infer<typeof Fr24FlightPositionsResponseSchema>
